<template>
  <div>
    <v-menu
      transition="slide-y-transition"
      bottom
      left
      offset-y
      content-class="elevation-1 mt-sm-3 wallet-menu-wrap"
      z-index="11"
      v-model="menuShowed"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex align-center" v-bind="attrs" v-on="on">
          <c-btn is-secondary is-short>
            <div class="d-flex align-center">
              <v-icon style="color: currentColor">mdi-menu</v-icon>
              <div class="ml-3">
                <div v-if="!isAuthenticated">Menu</div>
                <div v-else class="d-flex align-center">
                  <div class="primary--text d-none d-sm-block">
                    {{ displayAddress }}
                  </div>
                  <v-icon x-small class="ml-2 primary--text"
                    >fa-check-circle</v-icon
                  >
                </div>
              </div>
            </div>
          </c-btn>
        </div>
      </template>
      <v-card class="rounded-10 shadow-base wallet-menu" flat>
        <template v-if="isAuthenticated">
          <div>
            <div class="has-hover-effect rounded-8 pa-4" v-if="isUser">
              <router-link
                class="d-flex align-center justify-space-between text-decoration-none"
                :to="{ name: 'ManageAccount' }"
              >
                <div>{{ displayName }}</div>
                <div class="icon-wrap">
                  <v-icon x-small class="gray--text">fa-user-cog</v-icon>
                </div>
              </router-link>
            </div>
            <div class="pa-4" v-else>{{ displayName }}</div>
          </div>
          <v-divider />
        </template>
        <template v-if="wallets.length > 0">
          <div class="wallet-list">
            <div
              class="d-flex align-center justify-space-between py-2 px-4 has-hover-effect rounded-8"
              v-if="!project"
              @click="setCurrentWallet({})"
            >
              <div>
                <div class="d-flex align-center">
                  <div>All Wallets</div>
                  <img
                    v-if="!walletSelected.address"
                    class="ml-3"
                    src="@/assets/icons/check-circle.svg"
                    alt=""
                  />
                </div>
                <div class="mt-1 text-6 gray--text">Consolidated Portfolio</div>
              </div>
            </div>
            <div
              class="d-flex align-center justify-space-between py-2 px-4 has-hover-effect rounded-8"
              v-for="wallet in wallets"
              :key="wallet.id"
              @click="setCurrentWallet(wallet, true)"
            >
              <div>
                <div class="d-flex align-center">
                  <div>{{ wallet.label }}</div>
                  <img
                    v-if="
                      wallet.address ===
                        (walletSelected && walletSelected.address)
                    "
                    class="ml-3"
                    src="@/assets/icons/check-circle.svg"
                    alt=""
                  />
                </div>
                <div class="mt-1 text-6 gray--text">
                  {{ wallet.address.slice(0, 6) }}
                  <span>* * * * * *</span>
                  {{ wallet.address.slice(-4) }}
                </div>
              </div>
              <div class="d-flex align-center">
                <div
                  class="icon-wrap"
                  @click.stop="copyAddress(wallet.address)"
                >
                  <v-icon x-small class="gray--text">far fa-clone</v-icon>
                </div>
                <div class="icon-wrap ml-2" @click.stop>
                  <a
                    :href="
                      `${
                        projectByNetworkMap[wallet.coin_network].config
                          .explorerAddrLink
                      }${wallet.address}`
                    "
                    class="text-decoration-none d-flex"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <v-icon small class="gray--text">mdi-open-in-new</v-icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <v-divider />
        </template>
        <div class="pa-5">
          <c-btn class="width-100" @click="connectWallet">Connect Wallet</c-btn>
        </div>
        <v-divider />
        <template v-if="isAuthenticated">
          <div>
            <div class="has-hover-effect rounded-8 pa-4">
              <router-link
                class="d-flex align-center justify-space-between text-decoration-none"
                :to="{ name: 'ManageWallets' }"
              >
                <div>Manage Wallets</div>
                <div class="icon-wrap">
                  <v-icon x-small class="gray--text">fa-wallet</v-icon>
                </div>
              </router-link>
            </div>
          </div>
          <v-divider />
          <div>
            <div
              class="has-hover-effect rounded-8 d-flex align-center justify-space-between pa-4"
              @click="logout"
            >
              <div v-if="isUser">Log Out</div>
              <div v-else>Exit Session</div>
              <div class="icon-wrap">
                <v-icon x-small class="gray--text">fa-sign-out-alt</v-icon>
              </div>
            </div>
          </div>
          <v-divider />
        </template>
        <div class="menu-footer">
          <div class="has-hover-effect rounded-8 px-4 py-3 gray--text">
            Buy Crypto
          </div>
          <div class="has-hover-effect rounded-8 px-4 py-3 gray--text mt-2">
            <a
              href="mailto:support@unagii.com"
              class="gray--text text-decoration-none"
              >Contact Support</a
            >
          </div>
          <div
            class="has-hover-effect rounded-8 px-4 py-3 gray--text mt-2"
            @click="switchTheme"
          >
            Switch to
            <span class="text-lowercase">{{
              theme === "Dark" ? "Light" : "Dark"
            }}</span>
            mode
          </div>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isThemeDark } from "@/common/lib/utils";
import WALLETS from "@/common/config/wallets";

export default {
  computed: {
    ...mapGetters({
      authUser: "auth/user",
      isAuthenticated: "auth/isAuthenticated",
      isUser: "auth/isUser",
      isGuest: "auth/isGuest",
      walletList: "userWallets/walletList",
      walletSelected: "userWallets/walletSelected",
      userInfo: "userInfo/basicInfo",
      projectByNetworkMap: "projectConfig/projectByNetworkMap",
      project: "projectConfig/latestProject",
    }),
    walletMap() {
      return WALLETS.reduce((acc, cur) => ({ ...acc, [cur.name]: cur }), {});
    },
    wallets() {
      let wallets = this.walletList?.result ?? [];
      if (this.project) {
        wallets = wallets.filter(
          wl =>
            (wl.coin_network === this.project.config.network)
            &&
            (this.walletMap[wl.metadata?.type || wl.type].projects.includes(this.project.name))
        );
      }
      wallets = wallets
        .filter(item => this.projectByNetworkMap[item.coin_network])
        .sort((a, b) => b.isSelected - a.isSelected);
      return wallets;
    },
    displayAddress() {
      if (!this.walletList?.result?.length) return "Menu";
      if (this.walletSelected) {
        if (!this.walletSelected.address) return "All Wallets";
        return this.walletSelected.label;
      }
    },
    displayName() {
      if (this.isGuest) {
        return "Anonymous Unagii";
      }
      if (this.userInfo) {
        return (
          (this.userInfo.firstName + " " + this.userInfo.lastName).trim() ||
          this.userInfo.email
        );
      }
    },
  },
  data: () => ({
    menuShowed: false,
    theme: "Light",
  }),
  methods: {
    showAuthModal() {
      this.menuShowed = false;
      this.$store.dispatch("showAuthModal", "GetStarted");
    },
    showSelectWalletModal() {
      this.menuShowed = false;
      this.$store.dispatch("showSelectWalletModal");
    },
    connectWallet() {
      if (this.isAuthenticated) {
        this.showSelectWalletModal();
      } else {
        this.showAuthModal();
      }
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
    setCurrentWallet(wallet, showNoti) {
      this.menuShowed = false;
      if (showNoti) {
        this.$store.dispatch("addAlert", {
          type: "success",
          title: "Wallet switched",
          message: `Now connected to ${wallet.label}`,
        });
      }
      if (wallet.address) {
        if (!wallet.isSelected) {
          this.$store.dispatch("userWallets/updateWallet", {
            ...wallet,
            isSelected: true,
          });
        }
        if (
          this.walletSelected.coin_network === wallet.coin_network &&
          this.walletSelected.address !== wallet.address
        ) {
          this.$store.dispatch("userWallets/updateWallet", {
            ...this.walletSelected,
            isSelected: false,
          });
        }
      }
      this.$store.dispatch("userWallets/setCurrentWallet", wallet);
    },
    copyAddress(address) {
      navigator.clipboard.writeText(address).then(() => {
        this.$store.dispatch("addAlert", {
          title: "Success",
          type: "success",
          message: "Wallet address copied to clipboard.",
        });
      });
    },
    switchTheme() {
      if (this.theme === "Light") {
        this.theme = "Dark";
      } else {
        this.theme = "Light";
      }
    },
  },
  watch: {
    ["project.name"](value) {
      this.$nextTick(() => {
        if (value) {
          this.setCurrentWallet(this.wallets[0] || {});
        }
      });
    },
    ["wallets.length"](value) {
      this.$nextTick(() => {
        if (value && this.project && !this.walletSelected.address) {
          this.setCurrentWallet(this.wallets[0]);
        }
      });
    },
    menuShowed(value) {
      this.$nextTick(() => {
        const display = value ? "block" : "none";
        document.getElementById("menuOverlay2").style.display = display;
      });
    },
    theme(value) {
      localStorage.setItem("__unagii_theme__", value);
      this.$vuetify.theme.dark = isThemeDark();
    },
    $route() {
      this.menuShowed = false;
    },
    ["$vuetify.theme.dark"](value) {
      this.theme = value ? "Dark" : "Light";
      localStorage.setItem("__unagii_theme__", this.theme);
    },
  },
  created() {
    this.theme = localStorage.getItem("__unagii_theme__") || "Light";
    this.$vuetify.theme.dark = isThemeDark();
  },
};
</script>

<style lang="scss">
.wallet-menu {
  .wallet-list {
    max-height: 250px;
    overflow: hidden;
    &:hover {
      overflow: auto;
    }
  }
  > div {
    padding: 8px;
  }
  .icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: 28px;
    border: 1px solid var(--lightgray);
    border-radius: 50%;
  }
}
.wallet-menu-wrap {
  width: 300px;
  max-width: 100% !important;
  border-radius: 10px !important;
  @media (max-width: 599px) {
    width: 100vw !important;
    left: 0 !important;
    top: -12px !important;
    margin-top: 0 !important;
  }
  .theme-select-wrap {
    width: 115px;
    div.v-input__slot {
      min-height: auto !important;
      fieldset {
        border: 1px solid var(--lightgray) !important;
      }
      .v-select__selections {
        padding: 4px 0;
        .v-select__selection.v-select__selection--comma {
          color: var(--gray) !important;
        }
      }
      .v-input__append-inner {
        align-self: center !important;
        margin-top: 0 !important;
        .v-icon {
          color: var(--gray) !important;
        }
      }
    }
  }
}
.theme--light {
  .wallet-menu {
    border: none !important;
  }
}
.theme--dark {
  .wallet-menu {
    border: 1px solid var(--lightgray);
  }
}
</style>
